module.exports = __webpack_public_path__ + "img/eyes_male_asian_thin_mask.73a798d1.png";